import { useVisibilityStore } from '@/visibility/visibility.store';
import { goalbookUrls } from "@/util/links.js";

export default {
  beforeMount() {
    const visibilityStore = useVisibilityStore();
    if (!visibilityStore.betaVisibility) {
      window.location.replace(goalbookUrls.toolkitHome)
    }
  },
};